import useAxiosService from './useAxiosService'
import { IImportMedicineDetail, IMedicineImportDetail } from 'interfaces'
import { IResponse } from 'interfaces/services'
import {
  ICreateMedicine,
  IMedicineImportQuery,
  IMedicineUpdate
} from 'pages/repoImport/interfaces'

export const useRepoImportService = () => {
  const { post, get, patch, dele } = useAxiosService()

  const createMedicine = async (
    query: ICreateMedicine
  ): Promise<IResponse<any>> => {
    const response: any = await post(`/clinic/medicines`, query)
    return {
      ...response,
      data: response?.data
    } as IResponse<any>
  }

  const importMedicine = async (
    query: IMedicineImportQuery
  ): Promise<IResponse<any>> => {
    const response: any = await post(`/clinic/medicines/import`, query)
    return {
      ...response,
      data: response?.data
    } as IResponse<any>
  }

  const updateStatusMedicineImport = async (id: number, status: any) => {
    const response: any = await patch(
      `/clinic/medicines/import-detail/${id}`,
      status
    )
    return response as IResponse<any>
  }
  const appoveImport = async (id: number) => {
    const response: any = await post(
      `/clinic/medicines/import/${id}/approve`,
      {}
    )
    return response as IResponse<any>
  }

  const getImportMedicineDetails = async (id: number) => {
    const response: any = await get(`/clinic/medicines/import/${id}`, null)
    return response as IResponse<IImportMedicineDetail>
  }

  const getMedicineOfImportDetails = async (id: number) => {
    const response: any = await get(
      `/clinic/medicines/import-detail/${id}`,
      null
    )
    return response as IResponse<IMedicineImportDetail>
  }

  const updateMedicineImport = async (id: number, query: IMedicineUpdate) => {
    const response: any = await patch(
      `/clinic/medicines/import-detail/${id}`,
      query
    )
    return response as IResponse<IMedicineImportDetail>
  }
  const deleteMedicineImportDetail = async (id: number) => {
    const response: any = await dele(
      `/clinic/medicines/import-detail/${id}/delete`
    )
    return response as IResponse<any>
  }
  const addMedicineImportDetail = async (id: number, query: any) => {
    const response: any = await post(
      `clinic/medicines/import/${id}/add-medicines`,
      query
    )
    return response as IResponse<any>
  }
  const deleteLastItem = async (id: number) => {
    const response: any = await dele(`/clinic/medicines/import/${id}/delete`)
    return response as IResponse<any>
  }
  return {
    importMedicine,
    createMedicine,
    updateStatusMedicineImport,
    getImportMedicineDetails,
    getMedicineOfImportDetails,
    updateMedicineImport,
    deleteMedicineImportDetail,
    appoveImport,
    addMedicineImportDetail,
    deleteLastItem
  }
}
